<button
  class="c-button__inner"
  type="button"
  [disabled]="disabled() || loading()"
  [attr.aria-label]="ariaLabel() || null"
  (click)="onClick()"
>
  @if (icon() && iconPosition() === 'start') {
    <fa-icon class="c-button__icon" [icon]="icon()!" />
  }
  @if (!iconOnly()) {
    <span class="c-button__label"><ng-content /></span>
  }
  @if (icon() && iconPosition() === 'end') {
    <fa-icon class="c-button__icon" [icon]="icon()!" />
  }
  @if (loading()) {
    <ion-spinner name="crescent" class="c-button__spinner" />
  }
</button>
